import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';
const MessageIcon = (props: SvgProps) => (
  <Svg width={24} height={24} fill='none' {...props}>
    <Path
      fill='#FDFBF9'
      d='M4.688 18.862c-.43 0-.792-.149-1.09-.445a1.482 1.482 0 0 1-.444-1.09V6.673c0-.43.148-.793.445-1.09.297-.296.66-.445 1.09-.445h14.623c.43 0 .793.149 1.09.445.296.297.444.66.444 1.09v10.654c0 .43-.148.793-.445 1.09-.296.296-.66.445-1.09.445H4.689ZM12 12.052 4.077 6.869v10.454c0 .18.058.327.173.442a.599.599 0 0 0 .442.174h14.616c.18 0 .327-.058.442-.174a.599.599 0 0 0 .173-.442V6.87L12 12.052Zm0-1.037 7.6-4.953H4.4l7.6 4.953ZM4.077 6.87v-.807 11.261c0 .18.058.327.173.442a.599.599 0 0 0 .442.174h-.615V6.869Z'
    />
  </Svg>
);
export default MessageIcon;
